/**
 * The configuration warning of `Container::get_configuration_warnings()`
 * (container.cpp:207-214): `get_class() == "Container" && get_script().is_null()`.
 */
import { ruleRegistry } from '../../../../linter/RuleRegistry.js';
import { armDiagnostic, armEmits, groundedArm } from '../../../../linter/ruleArms.js';
import { resourceSlotIsEmpty } from '../../../../linter/resourceChecker.js';
const arms = {
    noScript: groundedArm('container-no-script', { kind: 'configuration-warning' }),
};
function checkContainer(context) {
    const { node } = context;
    // `null` reads to `Variant()` (variant_parser.cpp:699), `Object::set_script` then leaves no
    // instance (object.cpp:1092-1107), and `get_script()` (object.cpp:1134-1136) is null, as for
    // an absent key. `resourceSlotIsEmpty` gives every spelling that one answer.
    if (!resourceSlotIsEmpty(node.rawProperties.script))
        return [];
    return [
        armDiagnostic(arms.noScript, node, `Container '${node.name}' serves no purpose by itself unless a script configures its children's placement. If you don't intend to add a script, use a plain Control node instead.`),
    ];
}
const containerScriptRule = {
    meta: {
        name: 'valid-container-script',
        description: 'Flags a plain Container (the exact class, not a subclass) with no script attached — it places no children on its own',
        category: 'validation',
        // `get_class()`, not `is_class`: each descendant overrides `get_class()`, so
        // only the exact class warns, and `applicableNodeTypeMatcher` would be wrong here.
        exactClassByDesign: 'container.cpp:210',
        applicableNodeTypes: ['Container'],
        emits: armEmits(arms),
    },
    check: checkContainer,
};
ruleRegistry.register(containerScriptRule);
//# sourceMappingURL=linter.js.map